import React from "react";
import { useTranslation } from "react-i18next";
import ExpertisePageTemplate from "../components/ExpertisePageTemplate";

export default function DataPlatformsPage() {
  const { t } = useTranslation();
  const data = t("pillarPages.dataPlatforms", { returnObjects: true });

  return (
    <ExpertisePageTemplate
      pageKey="data-platforms"
      data={data}
      mediaSlotLabel={t("aboutPage.media.slot")}
      primaryHref="/contact"
    />
  );
}
